import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
  Link,
  useColorModeValue,
} from "@chakra-ui/react";

const Home = () => {
  const secondaryTextColor = useColorModeValue("gray.500", "gray.400");

  return (
    <Container maxW="3xl">
      <Stack
        as={Box}
        textAlign={"center"}
        spacing={{ base: 8, md: 12 }}
        py={{ base: 20, md: 24 }}
      >
        <Heading
          fontWeight={600}
          fontSize={{ base: "2xl", sm: "4xl", md: "6xl" }}
          lineHeight={"110%"}
        >
          Organize your <br />
          <Text as={"span"} color={"teal.400"}>
            tasks into lists
          </Text>
        </Heading>
        <Text color={secondaryTextColor}>
          Keep track of all your todos &amp; never let your todo lists get
          messy. Organize your tasks in different lists, which are easy for you
          to manage. Keep track of all your todos as all your data will be
          synced with your Google account.
        </Text>
        <Stack
          direction={"column"}
          spacing={3}
          align={"center"}
          alignSelf={"center"}
        >
          <Link as={RouterLink} to="/auth" _hover={{ textDecoration: "none" }}>
            <Button
              colorScheme={"teal"}
              bg={"teal.400"}
              rounded={"full"}
              px={6}
              _hover={{
                bg: "teal.500",
              }}
            >
              Create Account
            </Button>
          </Link>
          <Link as={RouterLink} to="/auth">
            <Button variant={"link"} colorScheme={"teal"} size={"sm"}>
              Login
            </Button>
          </Link>
        </Stack>
      </Stack>
    </Container>
  );
};

export default Home;
